import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex justify-center" }

import { computed, onMounted, ref } from 'vue'

import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreSelection',
  props: ['id'],
  setup(__props) {

const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const existingImages = computed(() => mapRelationships(store.value?.relationships.attachments.data))

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=attachments`)
  loading.value = false
})

const changeImage = image => {
  api.call('PUT', `stores/${props.id}?included=attachments`, {
    store: {
      attachments_attributes: image
    }
  })
}

return (_ctx, _cache) => {
  const _component_ImageUploaderNeue = _resolveComponent("ImageUploaderNeue")
  const _component_SettingsSection = _resolveComponent("SettingsSection")
  const _component_NeueLoading = _resolveComponent("NeueLoading")

  return (_openBlock(), _createBlock(_component_NeueLoading, { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SettingsSection, {
          title: "Store banner",
          description: "Shown across the top of this store's page, above your products, and on the card customers tap when they pick a store. A wide image works best - it is cropped to fit."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ImageUploaderNeue, {
                files: existingImages.value,
                editable: true,
                "display-multiple": false,
                onChange: changeImage
              }, null, 8, ["files"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}